import React from 'react';
import {MODAL_AI_SETTINGS, useSelector, showModal} from '@utils';
import {useTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faGear} from '@fortawesome/free-solid-svg-icons';
import {Spinner} from '@goproblems/ui';

const autoEngine = typeof OffscreenCanvas !== 'undefined' ? 'webgl' : 'wasm';
export const AiStatus = () => {
    const {t} = useTranslation();
    const {maxVisits, network, backend} = useSelector(s => s.aiSettings);
    const {avail, statusText} = useSelector(s => s.aiStatus);

    const backendText = backend === 'auto' ? `auto(${autoEngine})` : backend;

    return (
        <div className="flex font-semibold items-center text-neutral-500 justify-between">
            <div
                className="flex gap-2 items-center cursor-pointer"
                onClick={() => {
                    showModal(MODAL_AI_SETTINGS);
                }}>
                <span>{avail ? '🟢' : '🔴'}</span>
                <span>
                    {t('ai_settings.model')}: {network} /{' '}
                </span>
                <span>{backendText} / </span>
                <span>
                    {t('ai_settings.max_visits')}:{' '}
                    {maxVisits > 0 ? maxVisits : '∞'}
                </span>
                <FontAwesomeIcon icon={faGear} />
            </div>
            {statusText && (
                <div className={'flex items-center gap-2'}>
                    <span className={avail ? 'text-green-600' : ''}>
                        {t(statusText)}
                    </span>
                    {!avail && <Spinner size="sm" />}
                </div>
            )}
        </div>
    );
};
